const common = {
  "nav.home": "Accueil",
  "nav.services": "Services",
  "nav.about": "À Propos",
  "nav.pricing": "Tarifs",
  "nav.testimonials": "Avis",
  "nav.contact": "Contact",
  "nav.booking": "Rendez-vous",
  "nav.gallery": "Galerie",
  "nav.team": "Équipe",

  "hero.title_line1": "Votre Beauté.",
  "hero.title_line2": "Notre Art.",
  "hero.subtitle": "Dentisterie premium dans une atmosphère luxueuse. Des experts de renommée internationale pour votre nouveau sourire – jusqu'à 70% moins cher qu'en Allemagne/Autriche/Suisse.",
  "hero.cta": "Prendre Rendez-vous",
  "hero.badge": "CLINIQUE PREMIUM TIRANA · JUSQU’À 70% MOINS CHER QU’EN DE/AT/CH",
  "hero.stat1.value": "7 500+",
  "hero.stat1.label": "Patients",
  "hero.stat2.value": "15",
  "hero.stat2.label": "Ans d'Expérience",
  "hero.stat3.value": "98%",
  "hero.stat3.label": "Satisfaction",

  "services.tag": "NOS SERVICES",
  "services.heading": "L'Excellence dans Chaque Traitement",
  "services.dental.title": "Dentisterie",
  "services.dental.desc": "Implants dentaires, facettes, couronnes en zircone, blanchiment et plus. Prothèses premium avec diagnostic 3D de pointe – jusqu'à 70% moins cher.",
  "services.dental.count": "12 Traitements",
  "services.surgery.title": "Chirurgie Plastique",
  "services.surgery.desc": "Lifting visage, rhinoplastie, augmentation mammaire, liposuccion et plus. Normes de sécurité maximales avec hôtel et transfert inclus.",
  "services.surgery.count": "21 Interventions",
  "services.hair.title": "Greffe de Cheveux",
  "services.hair.desc": "Greffe de cheveux FUE avec technique de microponction de pointe. Jusqu'à 5.000 greffons – sans cicatrice, résultat naturellement dense. Analyse capillaire gratuite incluse.",
  "services.hair.count": "1 Traitement",
  "services.cta": "Découvrir Tous les Services",

  "about.tag": "NOTRE MAISON",
  "about.heading_line1": "La beauté, née en",
  "about.heading_line2": "Albanie.",
  "about.description": "Au cœur de Tirana, la vibrante capitale de l'Albanie, Esteva Clinic est née d'une vision : unir l'esthétique de classe mondiale à la chaleur de l'hospitalité méditerranéenne. L'Albanie — un pays d'une beauté à couper le souffle, des eaux turquoise de l'Adriatique aux sommets majestueux des Alpes albanaises — vit une renaissance spectaculaire. Alors que le pays devient rapidement l'une des destinations les plus prisées d'Europe, nous avons créé à Tirana un lieu où l'excellence médicale internationale rencontre le sentiment authentique d'être véritablement bienvenu. Notre clinique reflète l'esprit de l'Albanie : jeune, ambitieuse, pleine de cœur — et prête à conquérir le monde.",
  "about.quote": "L'Albanie m'a appris que la vraie beauté naît de l'authenticité. Ici, entre montagnes et mer, nous grandissons ensemble — le pays, notre équipe et chaque personne qui franchit nos portes.",
  "about.name": "Dr. Nertila Basha",
  "about.position": "CEO, Dentiste, Implantologue & Prothésiste",

  "pricing.tag": "FORFAITS",
  "pricing.heading_line1": "Excellence",
  "pricing.heading_line2": "Transparente.",
  "pricing.subtitle": "Chaque forfait adapté à vos besoins. Sans frais cachés, sans compromis.",
  "pricing.basic.title": "Essential",
  "pricing.basic.price": "à partir de 1.490 €",
  "pricing.basic.feature1": "Première consultation et analyse",
  "pricing.basic.feature2": "1 traitement au choix",
  "pricing.basic.feature3": "Forfait suivi Basic",
  "pricing.premium.title": "Premium",
  "pricing.premium.price": "à partir de 3.990 €",
  "pricing.premium.feature1": "Consultation VIP",
  "pricing.premium.feature2": "2 traitements combinés",
  "pricing.premium.feature3": "Suivi Premium et produits de soin",
  "pricing.luxe.title": "Luxe",
  "pricing.luxe.price": "à partir de 7.490 €",
  "pricing.luxe.feature1": "Concierge beauté personnel",
  "pricing.luxe.feature2": "3 traitements + forfait hôtel",
  "pricing.luxe.feature3": "1 an de suivi et garantie",
  "pricing.exclusive.title": "Exclusif",
  "pricing.exclusive.price": "Sur mesure",
  "pricing.exclusive.feature1": "Transformation complète",
  "pricing.exclusive.feature2": "Tous les traitements inclus",
  "pricing.exclusive.feature3": "Suivi à vie",
  "pricing.dental_title": "LISTE DES PRIX DENTAIRES",
  "pricing.surgery_title": "LISTE DES PRIX CHIRURGIE ESTHÉTIQUE",
  "pricing.hair_title": "LISTE DES PRIX GREFFE DE CHEVEUX",
  "pricing.included_title": "Services Inclus",
  "pricing.included_over_3000": "Pour les devis supérieurs à 3.000 € : hôtel, taxi, billet d'avion et scan 3D buccal sont inclus.",
  "pricing.included_over_1500": "Pour les devis supérieurs à 1.500 € : hôtel, taxi et scan 3D buccal sont inclus.",
  "pricing.table_service": "SERVICE",
  "pricing.table_price": "PRIX (EUR)",
  "pricing.table_stay": "SÉJOUR HÔPITAL & HÔTEL",
  "pricing.table_total": "TOTAL",
  "pricing.note_individual": "Les prix individuels peuvent varier selon la complexité de l'intervention. Un devis détaillé sera établi lors de votre consultation.",
  "pricing.cta": "Réserver une Consultation",
  "instagram.tag": "SUIVEZ-NOUS",
  "instagram.heading": "Aperçus d'Excellence.",
  "instagram.subtitle": "Rejoignez-nous sur Instagram pour des aperçus exclusifs, des transformations avant-après et les dernières tendances en médecine esthétique.",
  "instagram.cta": "Suivre @estevaclinic",

  "testimonials.tag": "TÉMOIGNAGES",
  "testimonials.heading": "Ce Que Disent Nos Clients",
  "testimonial1.text": "J'ai fait le voyage depuis Munich exprès — et honnêtement, la meilleure décision de ma vie. Cela fait 8 mois depuis ma rhinoplastie et le résultat est incroyablement naturel. Le Dr Krasniqi ne m'a rien promis qu'elle ne pouvait pas tenir, c'est ça qui m'a convaincu. La clinique est ultramoderne, l'équipe parle parfaitement français et le suivi post-opératoire était phénoménal. Pas un seul regret.",
  "testimonial1.name": "Markus W.",
  "testimonial1.role": "Rhinoplastie, Munich",
  "testimonial2.text": "Je voulais des facettes depuis des années mais les prix en Suisse étaient absurdes. Une amie m'a recommandé Esteva Clinic et je me suis dit : pourquoi pas ? La différence est — et je n'exagère pas — comme si on m'avait construit une bouche entièrement neuve. 12 facettes, parfaitement symétriques, absolument pas artificielles. Mon dentiste en Suisse était sans voix. Et en plus, Tirana est une ville magnifique, j'en ai profité pour des mini-vacances.",
  "testimonial2.name": "Sophie L.",
  "testimonial2.role": "Cosmétique Dentaire, Zurich",
  "testimonial3.text": "J'avais beaucoup de respect pour le lifting visage — toutes ces histoires de visages figés. Mais le Dr Krasniqi m'a tout expliqué calmement et m'a montré la technique SMAS. Le résultat ? Mes traits du visage sont raffermis, mais je ressemble à moi-même — juste 10 ans de moins. Personne ne remarque que j'ai fait quelque chose — mais tout le monde me dit : 'Tu as l'air si reposée !' Exactement ce que je voulais. Naturel, pas de visage masqué.",
  "testimonial3.name": "Chiara R.",
  "testimonial3.role": "Lifting Visage, Milan",
  "testimonial4.text": "J'ai lutté avec mes dents pendant 15 ans. Couronnes, bridges, provisoires — tout ça, c'est du vent. À 43 ans, je suis arrivé au point où je me suis dit : cette fois, je le fais correctement. 8 implants dentaires, 2 séances, à peine de douleur. Aujourd'hui, 10 mois plus tard, je mange et je ris pour la première fois depuis des années sans y penser. Le moment où ma fille a dit 'Papa, ton sourire est complètement différent' — ça valait chaque centime.",
  "testimonial4.name": "Alexander K.",
  "testimonial4.role": "Implants Dentaires, Hambourg",
  "testimonial5.text": "Je suis venue pour l'augmentation mammaire, je suis restée pour l'expérience complète. D'abord la chirurgie, puis l'équipe m'a convaincue de faire aussi des couronnes en zircone. Ils ont ce regard d'ensemble — ils comprennent comment tout s'harmonise. On ne se sent pas patiente, on se sent invitée. Dès la première minute. Et le café à Tirana est imbattable.",
  "testimonial5.name": "Isabella M.",
  "testimonial5.role": "Transformation Complète, Vienne",
  "testimonial6.text": "Le rapport qualité-prix est top, aucun doute. Mes nouvelles couronnes en zircone sont superbes et l'équipe était vraiment sympa. Seul petit bémol : la communication avant l'arrivée aurait pu être un peu plus claire — j'ai dû relancer deux fois pour les documents. Mais sur place, tout s'est déroulé sans accroc. 4 couronnes, 2 jours, résultat impeccable. Je reviendrais quand même.",
  "testimonial6.name": "Thomas G.",
  "testimonial6.role": "Couronnes Zircone, Berlin",
  "testimonial7.text": "Je suis allé en mars pour une greffe capillaire FUE (3 200 greffons). L'intervention était professionnelle, l'équipe s'est bien occupée de moi. Après 5 mois, on voit déjà une croissance nette, mais le résultat final reste évidemment à venir. J'attends avec impatience le 12e mois. La clinique est moderne, Tirana est une ville magnifique. Vol et hôtel inclus — tout s'est bien passé.",
  "testimonial7.name": "David R.",
  "testimonial7.role": "Greffe Capillaire, Francfort",
  "testimonial8.text": "J'y suis allée pour une petite rhinoplastie — l'intervention s'est bien passée et je suis satisfaite du résultat. Par contre, les premiers jours après l'opération étaient plus durs que prévu, j'aurais aimé être mieux préparée. Mais le suivi post-opératoire était excellent, l'équipe a vraiment fait des efforts. 6 mois plus tard, tout est parfaitement guéri.",
  "testimonial8.name": "Laura B.",
  "testimonial8.role": "Rhinoplastie, Stuttgart",

  "booking.tag": "RÉSERVATION",
  "booking.heading_line1": "Votre voyage commence",
  "booking.heading_line2": "par une conversation.",
  "booking.description": "Réservez dès maintenant votre consultation personnelle. Nos experts prennent le temps pour vos souhaits individuels et créent un concept de traitement sur mesure – discret et confidentiel.",
  "booking.cta": "Prendre Rendez-vous",
  "booking.hero_subtitle": "Choisissez votre date et votre heure préférées. Notre équipe vous répondra dans les 24 heures avec une confirmation.",
  "booking.select_date_hint": "Veuillez d'abord sélectionner une date pour voir les horaires disponibles.",
  "booking.your_data": "Vos Données",
  "booking.form_subtitle": "Remplissez le formulaire pour finaliser votre rendez-vous.",
  "booking.firstname": "Prénom *",
  "booking.firstname_placeholder": "Prénom",
  "booking.lastname": "Nom *",
  "booking.lastname_placeholder": "Nom",
  "booking.email": "E-mail *",
  "booking.email_placeholder": "votre@email.fr",
  "booking.phone": "Téléphone *",
  "booking.phone_placeholder": "+33 1 23 45 67 89",
  "booking.service_label": "Traitement Souhaité *",
  "booking.service_placeholder": "Sélectionner",
  "booking.service_combined": "Traitement Combiné",
  "booking.service_consultation": "Consultation",
  "booking.package_label": "Forfait Souhaité",
  "booking.package_undecided": "Encore indécis",
  "booking.package_essential": "Essential – à partir de 1.490 €",
  "booking.package_premium": "Premium – à partir de 3.990 €",
  "booking.package_luxe": "Luxe – à partir de 7.490 €",
  "booking.package_exclusif": "Exclusif – Sur mesure",
  "booking.message_label": "Demandes Spéciales ou Remarques",
  "booking.message_placeholder": "Faites-nous savoir sur quoi nous devons porter une attention particulière...",
  "booking.max_chars": "Max. 500 caractères",
  "booking.privacy_consent": "J'accepte que mes données soient stockées et traitées pour la prise de rendez-vous. J'ai pris connaissance de la politique de confidentialité.",
  "booking.select_datetime_warning": "Veuillez sélectionner une date et une heure pour finaliser la réservation.",
  "booking.success_title": "Merci pour votre réservation !",
  "booking.success_message": "Nous vous répondrons dans les 24 heures.",
  "booking.time_label": "Choisir l'Heure",
  "booking.time_selected": "Sélectionné :",
  "booking.time_unit": "h",

  "footer.tagline": "Esteva Clinic – Là où la beauté devient art.",
  "footer.services": "Services",
  "footer.about": "À Propos",
  "footer.legal": "Mentions Légales",
  "footer.contact": "Contact",
  "footer.hair": "Dentisterie",
  "footer.dental": "Dentisterie",
  "footer.surgery": "Chirurgie Plastique",
  "footer.botox": "Chirurgie Plastique",
  "footer.team": "Notre Équipe",
  "footer.philosophy": "Philosophie",
  "footer.career": "Carrière",
  "footer.press": "Presse",
  "footer.imprint": "Mentions Légales",
  "footer.privacy": "Confidentialité",
  "footer.terms": "CGV",
  "footer.faq": "FAQ",
  "footer.newsletter_title": "Restez Inspiré.",
  "footer.newsletter_subtitle": "Aperçus exclusifs, nouveaux traitements et offres spéciales directement dans votre boîte mail.",
  "footer.newsletter_placeholder": "Votre adresse e-mail",
  "footer.newsletter_button": "S'abonner",
  "footer.copyright": "© 2026 Esteva Clinic. Tous droits réservés.",
  "footer.seo_text": "Esteva Clinic est votre clinique de beauté et dentaire premium à Tirana, en Albanie. Nous proposons des implants dentaires, des couronnes en zircone, des facettes, la greffe de cheveux (FUE), l'augmentation mammaire, la rhinoplastie, le lifting, le Botox, la liposuccion et la chirurgie plastique jusqu'à 70% moins cher qu'en Suisse, en Allemagne et en Autriche. Les patients de Zurich, Bâle, Berne, Vienne, Munich et Berlin font confiance à Esteva Clinic. Première consultation gratuite — prenez rendez-vous dès maintenant.",

  "language.de": "DE",
  "language.it": "IT",
  "language.fr": "FR",
  "language.en": "EN",
  "language.sq": "SQ",

  "gallery.tag": "AVANT &amp; APRÈS",
  "gallery.heading_line1": "Des résultats qui",
  "gallery.heading_line2": "parlent d'eux-mêmes.",
  "gallery.subtitle": "De véritables transformations de nos clients. Chaque image raconte une histoire de confiance retrouvée et de beauté naturelle.",
  "gallery.filter_all": "Tous",
  "gallery.filter_hair": "Dentisterie",
  "gallery.filter_dental": "Dentisterie",
  "gallery.filter_surgery": "Chirurgie Plastique",
  "gallery.before": "Avant",
  "gallery.after": "Après",
  "gallery.view_details": "Voir Détails",
  "gallery.close": "Fermer",
  "gallery.no_results": "Aucun résultat trouvé dans cette catégorie.",
  "gallery.results_count": "{{count}} Résultats",
  "gallery.patient": "Patient",
  "gallery.treatment": "Traitement",
  "gallery.result_after": "Résultat après",
  "gallery.months": "mois",
  "gallery.disclaimer": "Les résultats présentés sont exemplaires. Les résultats individuels peuvent varier.",

  "service_detail.how_it_works": "LE PROCESSUS",
  "service_detail.benefits": "VOS AVANTAGES",
  "service_detail.faq": "FAQ",
  "service_detail.process_title": "Le Processus",
  "service_detail.benefits_title": "Vos Avantages",
  "service_detail.faq_title": "Questions Fréquentes",
  "service_detail.cta_heading": "Prêt pour Votre Transformation?",
  "service_detail.cta_subtitle": "Réservez dès maintenant votre consultation personnelle sans engagement. Nous prenons le temps pour vous.",
  "pricing.back_to_pricing": "Retour à la Liste de Prix",
  "pricing.view_details": "Détails",

  "team.tag": "NOTRE ÉQUIPE",
  "team.heading_line1": "L'excellence a besoin",
  "team.heading_line2": "de visages.",
  "team.subtitle": "Découvrez les experts qui font d'Esteva Clinic la destination de référence pour les traitements esthétiques premium en Europe. Chaque membre de l'équipe est un maître dans son domaine.",
  "team.show_more": "En savoir plus",
  "team.show_less": "Voir moins",
  "team.cta_heading": "Prêt pour votre transformation ?",
  "team.cta_subtitle": "Notre équipe a hâte de vous rencontrer et de vous accompagner dans votre parcours personnel vers une nouvelle beauté.",
  "team.cta_button": "Réservez une consultation",
  "clinic.tag": "NOTRE CLINIQUE",
  "clinic.heading_line1": "Des espaces conçus",
  "clinic.heading_line2": "pour votre bien-être.",
  "clinic.subtitle": "Clinique moderne et équipement de pointe à Tirana. Du confort du salon à l'hygiène du laboratoire dentaire — chaque détail pour votre bien-être.",
  "clinic.label_dental": "Laboratoire Dentaire",
  "clinic.label_consultation": "Cabinet de Consultation",
  "clinic.label_waiting": "Salle d'Attente",
  "clinic.label_reception": "Zone Réception",
  "clinic.dental_lab": "Laboratoire dentaire moderne avec équipement de dernière génération",
  "clinic.consultation": "Cabinet de consultation confortable pour entretiens personnels",
  "clinic.waiting": "Salle d'attente spacieuse et accueillante",
  "clinic.reception": "Zone réception moderne au design élégant",

  "process.tag": "VOTRE CHEMIN VERS NOUS",
  "process.heading": "Votre parcours médical, sans stress",
  "process.subtitle": "Nous vous guidons à chaque étape, garantissant une expérience sûre, confortable et réussie à la Esteva Clinic.",
  "process.step1.title": "Consultation",
  "process.step1.desc": "Nous comprenons vos besoins médicaux, votre historique clinique et vos attentes lors d'une consultation initiale en ligne avec nos spécialistes.",
  "process.step2.title": "Plan Personnalisé",
  "process.step2.desc": "Nous créons un plan de traitement personnalisé incluant tous les détails de la procédure, les délais, les coûts et l'organisation complète du voyage.",
  "process.step3.title": "Révision Médicale et Préparation",
  "process.step3.desc": "Notre équipe analyse vos dossiers médicaux et prépare chaque détail à l'avance — y compris les documents, le voyage et l'hébergement.",
  "process.step4.title": "Traitement et Soins",
  "process.step4.desc": "Vous recevez un traitement de haute qualité à la Esteva Clinic avec une attention maximale et une expérience confortable.",
  "process.step5.title": "Suivi et Support",
  "process.step5.desc": "Nous restons à vos côtés même après le traitement, offrant un support continu et des conseils pour une guérison optimale.",
  "trust.heading_line1": "Nous transformons les soins",
  "trust.heading_line2": "en une expérience de confiance.",
  "trust.subtitle": "Faites confiance à l'équipe de la Esteva Clinic pour recevoir des soins médicaux de haute qualité, des traitements personnalisés et un support complet tout au long de votre processus de guérison.",
  "trust.check1": "Consultation médicale spécialisée",
  "trust.check2": "Examens et diagnostic avancés",
  "trust.check3": "Chirurgie générale et spécialisée",
  "trust.check4": "Traitements personnalisés pour patients internationaux",
  "trust.check5": "Assistance dédiée pour le tourisme médical",
  "trust.check6": "Support avant, pendant et après le traitement",

  "dental.tag": "EXPERTISE DENTAIRE",
  "dental.heading": "Votre nouveau sourire commence ici",
  "dental.subtitle": "Solutions modernes pour votre sourire : implants dentaires, All-on-4 / All-on-6 / All-on-8, smile design, avec des matériaux de haute qualité et des résultats naturels.",
  "dental.implant.title": "Implants Dentaires Premium",
  "dental.implant.desc": "Implants dentaires en titane, résistants et naturels, pour retrouver la fonction et l'esthétique de votre sourire à long terme.",
  "dental.crown.title": "Couronnes en Zircone",
  "dental.crown.desc": "Couronnes en zircone esthétiques et résistantes, conçues pour offrir un résultat naturel et durable.",
  "dental.veneer.title": "Facettes Dentaires",
  "dental.veneer.desc": "Facettes esthétiques fines et naturelles, idéales pour corriger la forme, la couleur et l'alignement des dents.",
  "dental.allon4.title": "All-on-4",
  "dental.allon4.desc": "Solution innovante avec 4 implants dentaires par arcade, permettant d'obtenir des dents fixes, stables et naturelles.",
  "dental.allon6.title": "All-on-6",
  "dental.allon6.desc": "Technique avancée avec 6 implants dentaires par arcade, garantissant une stabilité et une fonctionnalité maximales.",
  "dental.allon8.title": "All-on-8",
  "dental.allon8.desc": "Solution complète avec 8 implants dentaires par arcade, idéale pour assurer un support maximal et une fonctionnalité à 100%.",
  "dental.pterygoid.title": "Implants Ptérygoïdiens",
  "dental.pterygoid.desc": "Technique avancée utilisant des implants ptérygoïdiens pour éviter les greffes osseuses, permettant des dents fixes même dans les cas complexes avec peu d'os.",
  "dental.zygomatic.title": "Implants Zygomatiques",
  "dental.zygomatic.desc": "Solution avancée utilisant des implants zygomatiques pour les patients avec une perte osseuse sévère, évitant les greffes et garantissant une stabilité immédiate et des résultats durables.",
  "dental.maxillofacial.title": "Chirurgie Maxillo-Faciale",
  "dental.maxillofacial.desc": "Interventions spécialisées pour traiter les problèmes complexes de la bouche, de la mâchoire et du visage, avec des techniques modernes et une sécurité maximale.",
  "dental.cta": "En savoir plus",
  "overview.tag": "NOS SPÉCIALITÉS",
  "overview.heading": "Trois Disciplines. Une Exigence.",
  "overview.subtitle": "Dentisterie, chirurgie plastique et greffe de cheveux — chaque spécialité avec des experts de renommée internationale, une technologie de pointe et un seul objectif : votre beauté naturelle.",
  "overview.dental.title": "Dentisterie",
  "overview.dental.desc": "Des implants unitaires à la réhabilitation buccale complète. Diagnostic 3D de dernière génération, matériaux de haute qualité et une équipe d'implantologues expérimentés pour votre nouveau sourire.",
  "overview.dental.treatments": "Implants, Couronnes Zircone, Facettes, All-on-4/6/8, Blanchiment, Orthodontie, Greffe Osseuse, Sinus Lift, Implants Ptérygoïdiens et Zygomatiques",
  "overview.surgery.title": "Chirurgie Plastique",
  "overview.surgery.desc": "Interventions esthétiques au plus haut niveau. De la rhinoplastie au lifting facial en passant par le remodelage corporel — des concepts individuels avec une sécurité maximale et des résultats naturels.",
  "overview.surgery.treatments": "Rhinoplastie, Lifting Facial, Augmentation et Réduction Mammaire, Blépharoplastie, Liposuccion, Abdominoplastie, Lifting des Bras et Cuisses, Ballon Gastrique",
  "overview.hair.title": "Greffe de Cheveux",
  "overview.hair.desc": "Technique FUE par microponction la plus avancée pour un résultat naturellement dense et sans cicatrice. Jusqu'à 5 000 greffons en une séance — avec analyse capillaire gratuite et plan de traitement personnalisé.",
  "overview.hair.treatments": "Greffe de Cheveux FUE (jusqu'à 5 000 greffons), Analyse Capillaire Gratuite, Plan de Traitement Personnalisé, Résultat Naturel Permanent",
  "overview.cta": "Tous les Traitements et Prix",
  "implants.hero_title": "Implants Dentaires Premium en Albanie",
  "implants.hero_subtitle": "Retrouvez le plaisir de sourire, mâcher et parler en toute sécurité grâce à nos implants dentaires premium à la Esteva Clinic.",
  "implants.hero_desc": "Nous proposons des solutions implantaires modernes, sûres et personnalisées pour les patients recherchant qualité, esthétique et stabilité à long terme.",
  "implants.why_title": "Pourquoi choisir nos implants dentaires ?",
  "implants.why_intro": "Les implants dentaires sont une solution fixe et durable pour remplacer des dents manquantes ou gravement compromises. À la Esteva Clinic, chaque cas est étudié avec attention pour offrir un traitement sûr, esthétique et fonctionnel.",
  "implants.benefit1_title": "Matériaux premium",
  "implants.benefit1_desc": "Nous utilisons des matériaux sélectionnés pour garantir résistance, biocompatibilité et fiabilité dans le temps.",
  "implants.benefit2_title": "Plan personnalisé",
  "implants.benefit2_desc": "Chaque patient reçoit une évaluation individuelle et un plan de traitement créé en fonction de ses besoins.",
  "implants.benefit3_title": "Esthétique naturelle",
  "implants.benefit3_desc": "L'objectif est d'obtenir des dents fixes, belles et naturelles, en harmonie avec le sourire du patient.",
  "implants.when_title": "Quand les implants dentaires sont-ils indiqués ?",
  "implants.when_desc": "Les implants dentaires sont indiqués lorsqu'il manque une ou plusieurs dents, lorsque les dents naturelles ne peuvent plus être sauvées ou lorsqu'une prothèse amovible n'offre pas stabilité et confort.",
  "implants.when_desc2": "Ils peuvent être utilisés pour remplacer une seule dent, plusieurs dents ou une arcade complète avec des solutions fixes comme All-on-4, All-on-6 ou Toronto Bridge.",
  "implants.path_title": "Notre parcours implantaire",
  "implants.path_step1_title": "1. Évaluation",
  "implants.path_step1_desc": "Analyse du cas, consultation spécialisée et étude de la situation dentaire.",
  "implants.path_step2_title": "2. Plan de soins",
  "implants.path_step2_desc": "Création d'un plan personnalisé avec délais, matériaux et coûts clairs.",
  "implants.path_step3_title": "3. Insertion des implants",
  "implants.path_step3_desc": "Procédure réalisée par une équipe médicale expérimentée dans un environnement sûr et contrôlé.",
  "implants.path_step4_title": "4. Dents fixes",
  "implants.path_step4_desc": "Réalisation de la prothèse finale pour un sourire stable, fonctionnel et esthétique.",
  "implants.cta_title": "Demandez une évaluation personnalisée",
  "implants.cta_desc": "Envoyez une panoramique dentaire ou contactez-nous pour recevoir une première évaluation. Notre équipe vous guidera vers la solution la plus adaptée à votre cas.",
  "implants.cta_button": "Prendre rendez-vous",

  "imprint.title": "Mentions Légales",
  "imprint.responsible": "Responsable du Contenu",
  "imprint.address_label": "Adresse",
  "imprint.phone_label": "Téléphone",
  "imprint.email_label": "E-mail",
  "imprint.authorized_label": "Représentants Légaux",
  "imprint.register_label": "Registre du Commerce",
  "imprint.vat_label": "Numéro de TVA",
  "imprint.disclaimer_title": "Exclusion de Responsabilité",
  "imprint.disclaimer_text": "Le contenu de ce site web est élaboré avec le plus grand soin. Cependant, nous ne pouvons garantir l'exactitude, l'exhaustivité et l'actualité du contenu. Malgré un contrôle minutieux du contenu, nous n'assumons aucune responsabilité pour le contenu des liens externes. Les exploitants des pages liées sont seuls responsables de leur contenu.",
  "imprint.copyright_title": "Droit d'Auteur",
  "imprint.copyright_text": "Les contenus et œuvres créés par les exploitants du site sur ces pages sont soumis au droit d'auteur. La reproduction, l'édition, la distribution et toute forme d'exploitation en dehors des limites du droit d'auteur nécessitent l'accord écrit de l'auteur ou du créateur concerné.",
  "imprint.data_protection_link": "Politique de Confidentialité",

  "booking.find_us": "NOUS TROUVER",
  "booking.visit_us": "Visitez-nous à Tirana",
  "booking.visit_subtitle": "Notre clinique est située au cœur de Tirana. Prenez rendez-vous et venez nous rencontrer en personne.",

  "agb.title": "Conditions Générales",
  "agb.meta_desc": "Conditions Générales de la plateforme d'intermédiation Esteva.ch. Informations sur le champ d'application, la responsabilité, les prestations et le droit applicable.",

  "hero.discover_prices": "Découvrir les prix",

  "services.hero_subtitle": "Trois disciplines, une exigence : la perfection absolue. Dentisterie, chirurgie plastique et transplantation capillaire au cœur de Tirana – jusqu'à 70% moins cher qu'en DE/AT/CH.",
  "services.page_cta_title": "Prêt pour votre transformation ?",
  "services.page_cta_subtitle": "Réservez maintenant votre consultation personnelle à Tirana. Notre équipe d'experts créera un concept de traitement sur mesure – parfaitement adapté à vos souhaits.",

  "testimonials.hero_subtitle": "De vraies transformations, de vraies émotions. Nos clients viennent de toute l'Europe à Tirana — et repartent avec un nouveau sentiment de vie.",
  "testimonials.rating": "★ 4.9 / 5.0 — basé sur plus de 240 avis vérifiés de nos clients à travers l'Europe.",
  "testimonials.cta_title": "Faites partie de nos histoires de succès",
  "testimonials.cta_subtitle": "Votre transformation commence par une conversation. Découvrons ensemble comment nous pouvons sublimer votre beauté naturelle.",
  "testimonials.hero_tag": "TÉMOIGNAGES RÉELS",
  "testimonials.filter_all": "Tous",
  "testimonials.filter_dental": "Dentisterie",
  "testimonials.filter_surgery": "Chirurgie",
  "testimonials.filter_hair": "Greffe capillaire",
  "testimonials.based_on": "Basé sur {{count}} avis vérifiés",
  "testimonials.rating_breakdown": "Répartition des notes",
  "testimonials.verified": "Vérifié",
  "testimonials.time_ago_months": "il y a {{count}} mois",
  "testimonials.time_ago_months_one": "il y a 1 mois",
  "testimonials.time_ago_years": "il y a {{count}} an",
  "testimonials.time_ago_years_plural": "il y a {{count}} ans",
  "testimonials.empty_title": "Aucun avis dans cette catégorie",
  "testimonials.empty_subtitle": "Consultez une autre catégorie ou parcourez tous les avis.",

  "about.vision_title": "Une vision née en Méditerranée",
  "about.vision_para2": "Fondée par Dr. Nertila Basha, spécialiste de médecine esthétique formée à l'international, Esteva Clinic réunit le meilleur de deux mondes : la précision et le savoir-faire de la médecine d'excellence internationale avec la chaleureuse et authentique hospitalité des Balkans. Notre équipe de 11 experts — dont des spécialistes en chirurgie capillaire, cosmétique dentaire et médecine esthétique — travaille main dans la main pour obtenir le résultat optimal pour chaque client.",
  "about.meet_team_link": "Découvrir notre équipe",
  "about.albania_title": "L'Albanie — un pays en plein essor",
  "about.albania_subtitle": "Tirana n'est plus un secret. La capitale albanaise se développe rapidement pour devenir l'un des centres économiques et culturels les plus dynamiques d'Europe du Sud-Est — et Esteva Clinic est au cœur de tout cela.",
  "about.albania_card1_title": "Miracle économique des Balkans",
  "about.albania_card1_desc": "L'Albanie enregistre une croissance record depuis des années. Les investissements internationaux, les infrastructures modernes et une population jeune et très motivée font de Tirana un hotspot pour l'innovation et le progrès.",
  "about.albania_card2_title": "Une nature qui enthousiasme",
  "about.albania_card2_desc": "De la mer Adriatique turquoise à l'ouest aux majestueuses Alpes albanaises au nord — l'Albanie unit la légèreté méditerranéenne à la grandeur alpine dans le plus petit des espaces.",
  "about.albania_card3_title": "Le nouvel aimant de l'Europe",
  "about.albania_card3_desc": "De plus en plus de voyageurs, de nomades numériques et d'entreprises internationales découvrent l'Albanie. Tirana a été désignée par le Time Magazine comme l'une des villes les plus passionnantes du monde.",
  "about.experience_title": "Vivez Esteva Clinic par vous-même",
  "about.experience_subtitle": "Rendez-nous visite à Tirana. Ou commencez par une consultation personnelle — sur place ou en ligne.",

  "booking.form_name_label": "Nom",
  "booking.form_name_placeholder": "Votre nom complet",
  "booking.form_phone_short": "Téléphone",
  "booking.form_treatment_label": "Traitement souhaité",
  "booking.form_message_optional": "Message (optionnel)",
  "booking.form_select_please": "Veuillez sélectionner",
  "booking.form_message_short_placeholder": "Votre message pour nous...",
  "booking.opening_hours_label": "Horaires d'Ouverture",
  "booking.day_mofr": "Lun – Ven",
  "booking.day_saturday": "Samedi",
  "booking.day_sunday": "Dimanche",
  "booking.day_closed": "Fermé",
  "booking.albania_text": "Albanie",

  "contact.hero_tag": "Nous sommes là pour vous",
  "contact.hero_title_line1": "Écrivez-nous.",
  "contact.hero_title_line2": "Nous répondons dans les 24h.",
  "contact.hero_subtitle": "Consultation gratuite, demande de devis ou simplement des questions — l'équipe Esteva se réjouit de votre message.",
  "contact.form_title": "Envoyer un message",
  "contact.form_required_hint": "Tous les champs marqués d'un * sont obligatoires.",
  "contact.firstname_label": "Prénom",
  "contact.lastname_label": "Nom",
  "contact.phone_optional": "Téléphone",
  "contact.subject_label": "Sujet",
  "contact.subject_placeholder": "Veuillez sélectionner...",
  "contact.subject_dental": "Dentisterie & Implants",
  "contact.subject_surgery": "Chirurgie Plastique",
  "contact.subject_hair": "Greffe de Cheveux",
  "contact.subject_general": "Consultation Générale",
  "contact.subject_price": "Demande de Devis",
  "contact.subject_other": "Autre",
  "contact.message_label": "Votre message",
  "contact.message_max": "(max. 500 caractères)",
  "contact.privacy_contact": "J'ai lu la politique de confidentialité et j'accepte que mes données soient utilisées pour traiter ma demande.",
  "contact.sending": "Envoi en cours...",
  "contact.submit": "Envoyer le message",
  "contact.success_title": "Merci !",
  "contact.success_message": "Votre message a bien été reçu. Nous vous répondrons dans les 24 heures.",
  "contact.new_message": "Envoyer un nouveau message",
  "contact.info_title": "Informations de Contact",
  "contact.follow_us": "Suivez-nous",
  "contact.book_title": "Vous préférez directement ?",
  "contact.book_online": "Prendre rendez-vous en ligne",
  "contact.book_free": "Consultation gratuite",
  "contact.maps_open": "Ouvrir dans Google Maps",
  "contact.find_us_label": "NOUS TROUVER",
  "contact.opening_hours": "Horaires d'Ouverture",
  "contact.address_label": "Adresse",
  "contact.monday_friday": "Lun – Ven",
  "contact.saturday": "Samedi",
  "contact.sunday": "Dimanche",
  "contact.closed": "Fermé",
  "instagram.followers": "Abonnés",
  "instagram.posts": "Publications",
  "instagram.likes_label": "J'aime",

  // ══════════════════════════════════════════
  // SEO Meta Tags – multilingual
  // ══════════════════════════════════════════
  "seo.ogLocale": "fr_FR",
  "seo.home.title": "Esteva Clinic – Dentisterie Premium & Chirurgie Plastique | Cosmétique Dentaire & Chirurgie Esthétique à Tirana",
  "seo.home.description": "Esteva Clinic à Tirana, Albanie – Votre clinique premium de dentisterie et chirurgie plastique. Implants dentaires, facettes, lifting visage, rhinoplastie et plus. Équipe internationale d'experts. Jusqu'à 70% moins cher qu'en DE/AT/CH. Réservez votre consultation.",
  "seo.home.keywords": "Esteva Clinic, dentisterie Tirana, chirurgie plastique Albanie, implants dentaires, facettes, lifting visage, rhinoplastie, augmentation mammaire, tourisme dentaire, chirurgie esthétique étranger, médecine esthétique Tirana",
  "seo.about.title": "À Propos – Esteva Clinic | Clinique Premium de Beauté à Tirana, Albanie",
  "seo.about.description": "Esteva Clinic à Tirana, Albanie : Notre histoire, philosophie et équipe internationale d'experts. Découvrez pourquoi nous sommes la référence pour l'esthétique premium au cœur des Balkans.",
  "seo.about.keywords": "Esteva Clinic Tirana, dentisterie Albanie, chirurgie plastique Tirana, médecine esthétique Tirana, Dr. Nertila Basha, clinique premium Balkans, tourisme dentaire Albanie",
  "seo.services.title": "Services – Esteva Clinic | Dentisterie, Chirurgie & Greffe Capillaire à Tirana",
  "seo.services.description": "Services Esteva Clinic à Tirana : Dentisterie premium avec implants dentaires, facettes, couronnes zircone, chirurgie plastique et greffe capillaire FUE jusqu'à 5 000 greffons. Jusqu'à 70% moins cher qu'en DE/AT/CH.",
  "seo.services.keywords": "Dentisterie Tirana, chirurgie plastique Albanie, greffe capillaire Tirana, greffe FUE, implants dentaires, lifting visage, rhinoplastie, services Esteva Clinic",
  "seo.pricing.title": "Liste des Prix Dentaire, Chirurgie & Greffe Capillaire – Esteva Clinic Tirana | Coûts Transparents",
  "seo.pricing.description": "Liste complète des prix Esteva Clinic Tirana : Implants dentaires à partir de 350 €, rhinoplastie à partir de 2 200 €, greffe FUE à partir de 1 500 €. Tous les prix incluent hôtel, taxi et scan 3D.",
  "seo.pricing.keywords": "Prix Esteva Clinic, liste prix dentaire Tirana, coût implants dentaires, prix chirurgie plastique Albanie, coût greffe capillaire, greffe FUE, coût rhinoplastie, prix augmentation mammaire",
  "seo.testimonials.title": "Avis – Esteva Clinic | Expériences Clients Réelles de Tirana",
  "seo.testimonials.description": "Avis réels des clients Esteva Clinic : Dentisterie et chirurgie plastique à Tirana. Découvrez pourquoi nos clients viennent de toute l'Europe – jusqu'à 70% moins cher.",
  "seo.testimonials.keywords": "Avis Esteva Clinic, expériences dentisterie, témoignages chirurgie plastique, avis lifting visage, expériences implants dentaires, témoignages médecine esthétique",
  "seo.booking.title": "Prendre Rendez-vous – Esteva Clinic | Consultation à Tirana",
  "seo.booking.description": "Réservez votre consultation personnelle chez Esteva Clinic à Tirana. Dentisterie, chirurgie plastique et médecine esthétique. Première consultation gratuite – jusqu'à 70% moins cher qu'en DE/AT/CH.",
  "seo.booking.keywords": "Consultation Tirana, réservation Esteva Clinic, rendez-vous dentisterie, consultation chirurgie plastique, consultation lifting visage, consultation implants dentaires, réservation clinique beauté",
  "seo.gallery.title": "Galerie – Esteva Clinic | Résultats Avant & Après de Tirana",
  "seo.gallery.description": "Impressionnants résultats avant-après d'Esteva Clinic à Tirana : Implants dentaires, facettes, lifting visage, rhinoplastie et plus. Résultats réels de vrais clients de toute l'Europe.",
  "seo.gallery.keywords": "Galerie avant après, résultats dentisterie, résultats facettes, transformations lifting visage, résultats rhinoplastie, Esteva Clinic, images médecine esthétique",
  "seo.team.title": "Équipe – Esteva Clinic | Équipe Internationale d'Experts à Tirana",
  "seo.team.description": "Rencontrez l'équipe internationale d'experts d'Esteva Clinic à Tirana. Spécialistes en dentisterie, chirurgie plastique et médecine esthétique. Multilingues, expérimentés, passionnés.",
  "seo.team.keywords": "Équipe Esteva Clinic, Esteva Clinic Tirana, chirurgiens plastiques Tirana, experts dentisterie Albanie, spécialistes dentaires, médecins chirurgie esthétique",
  "seo.contact.title": "Contact – Esteva Clinic | Demandez une Consultation à Tirana",
  "seo.contact.description": "Contactez Esteva Clinic à Tirana. Consultation gratuite pour dentisterie, chirurgie plastique et greffe capillaire. Envoyez votre demande maintenant !",
  "seo.contact.keywords": "Contact Esteva Clinic, consultation Tirana, demande dentisterie, consultation chirurgie Albanie",
  "seo.imprint.title": "Mentions Légales – Esteva Clinic | Rruga Bylis, Tiranë 1001, Albanie",
  "seo.imprint.description": "Mentions légales d'Esteva Clinic Tirana. Informations légales, responsables, adresse et coordonnées d'Esteva Clinic en Albanie.",
  "seo.imprint.keywords": "Mentions légales, Esteva Clinic, Tirana, Albanie, informations légales, contact Esteva Clinic",
  "seo.dental_implants.title": "Implants Dentaires Premium – Esteva Clinic | Dentisterie Tirana",
  "seo.dental_implants.description": "Implants dentaires premium à Tirana, Albanie. Solutions implantaires modernes, sûres et personnalisées. Jusqu'à 70% moins cher qu'en DE/AT/CH. Demandez votre consultation gratuite.",
  "seo.dental_implants.keywords": "Implants dentaires Tirana, implants dentaires Albanie, coût implants, All-on-4 Tirana, All-on-6 Albanie, Esteva Clinic implants",
  "seo.agb.keywords": "CGV, Esteva Clinic, conditions, Esteva.ch",

  // ══════════════════════════════════════════
  // Politique de Confidentialité
  // ══════════════════════════════════════════
  "privacy.title": "Politique de Confidentialité",
  "privacy.subtitle": "Esteva.ch — Plateforme d'Intermédiation pour Services Médicaux et Esthétiques",
  "privacy.date": "Dernière mise à jour : 11 juin 2026",
  "privacy.last_updated": "Dernière mise à jour",
  "privacy.s1_title": "1. Responsable du Traitement",
  "privacy.s1_text": "Le responsable du traitement des données sur cette plateforme est :\n\nAI Vision GmbH\nUnterdorf 8, 8222 Beringen, Suisse\nEmail : info@esteva.ch\n(Intermédiaire / Exploitant de la Plateforme)\n\nCo-responsable pour le traitement de vos demandes médicales :\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albanie\n\nLa présente politique de confidentialité s'applique conformément à la loi fédérale suisse sur la protection des données (LPD/nLPD) et, le cas échéant, au Règlement Général sur la Protection des Données de l'UE (RGPD).",
  "privacy.s2_title": "2. Quelles Données Nous Collectons",
  "privacy.s2_text": "Nous collectons les catégories suivantes de données personnelles :\n\n• Données de contact : nom, adresse email, numéro de téléphone\n• Demandes de traitement et consultations (fournies volontairement)\n• Données techniques : adresse IP, type de navigateur, heure de visite, pages consultées\n• Données de communication : messages via formulaires de contact ou WhatsApp\n\nNous ne collectons pas de catégories particulières de données personnelles (ex. données de santé) sans votre consentement explicite.",
  "privacy.s3_title": "3. Finalité du Traitement des Données",
  "privacy.s3_text": "Vos données sont utilisées exclusivement aux fins suivantes :\n\n• Intermédiation vers le prestataire de services souhaité (clinique)\n• Réponse aux demandes et prise de rendez-vous\n• Amélioration de la plateforme et gestion technique\n• Respect des obligations légales",
  "privacy.s4_title": "4. Partage des Données",
  "privacy.s4_text": "4.1 Vos données de contact et votre demande de traitement seront transmises au prestataire de services que vous avez sélectionné (clinique en Albanie) afin qu'il puisse traiter votre demande.\n\n4.2 Nous ne partageons pas vos données avec des tiers à des fins commerciales.\n\n4.3 Le transfert de données à l'étranger (Albanie) est basé sur votre consentement. L'Albanie n'est pas considérée comme un pays offrant un niveau de protection des données équivalent à celui de la Suisse ; le transfert est fondé sur votre consentement explicite conformément à l'Art. 17 nLPD.",
  "privacy.s5_title": "5. Cookies et Suivi",
  "privacy.s5_text": "5.1 Notre plateforme utilise des cookies techniquement nécessaires au fonctionnement du site web.\n\n5.2 Nous pouvons utiliser des outils d'analyse (ex. Google Analytics). Vous pouvez vous opposer à l'utilisation des cookies d'analyse à tout moment.\n\n5.3 Vous pouvez désactiver les cookies dans les paramètres de votre navigateur ; cela peut limiter la fonctionnalité de la plateforme.",
  "privacy.s6_title": "6. Durée de Conservation",
  "privacy.s6_text": "Nous conservons vos données personnelles uniquement pendant la durée nécessaire aux finalités indiquées. Les données de demande seront supprimées après un maximum de 2 ans.",
  "privacy.s7_title": "7. Vos Droits",
  "privacy.s7_text": "Vous disposez des droits suivants concernant vos données personnelles :\n\n• Droit d'accès : informations sur les données stockées\n• Droit de rectification : correction des données inexactes\n• Droit à l'effacement : suppression de vos données sauf obligations légales\n• Droit d'opposition : opposition au traitement des données\n• Droit à la portabilité : transmission de vos données dans un format courant\n\nPour exercer vos droits : info@esteva.ch\n\nLes réclamations peuvent être adressées au Préposé Fédéral à la Protection des Données et à la Transparence (PFPDT) : www.edoeb.admin.ch",
  "privacy.s8_title": "8. Sécurité des Données",
  "privacy.s8_text": "Nous prenons des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles (ex. chiffrement SSL/TLS).",
  "privacy.s9_title": "9. Services Tiers",
  "privacy.s9_text": "La plateforme peut utiliser les services tiers suivants :\n\n• Google Maps — Politique de confidentialité : policies.google.com/privacy\n• WhatsApp Business — Politique de confidentialité : www.whatsapp.com/legal/privacy-policy",
  "privacy.s10_title": "10. Modifications de la Présente Politique",
  "privacy.s10_text": "Nous nous réservons le droit de modifier la présente politique de confidentialité à tout moment. La version actuelle est disponible sur www.Esteva.ch.\n\nAI Vision GmbH | Unterdorf 8, 8222 Beringen | info@esteva.ch | www.Esteva.ch",

  // SEO
  "seo.privacy.title": "Politique de Confidentialité – Esteva.ch | AI Vision GmbH, Beringen, Suisse",
  "seo.privacy.description": "Politique de confidentialité de la plateforme d'intermédiation Esteva.ch. Informations sur la collecte, le traitement et le partage des données personnelles conformément à la LPD/nLPD suisse et au RGPD de l'UE. Responsable du traitement : AI Vision GmbH, Beringen, Suisse.",
  "seo.privacy.keywords": "Politique de confidentialité, Esteva.ch, AI Vision GmbH, protection des données, LPD, nLPD, RGPD, données personnelles, Beringen, Suisse",

  // ══════════════════════════════════════════
  // Admin-Dashboard
  // ══════════════════════════════════════════
  "admin.logo": "ESTEVA ADMIN",
  "admin.to_website": "Voir le Site",
  "admin.logout": "Déconnexion",
  "admin.sidebar_expand": "Déplier la barre",
  "admin.sidebar_collapse": "Replier la barre",
  "admin.nav_dashboard": "Aperçu",
  "admin.nav_pages": "Pages & Contenu",
  "admin.nav_treatments": "Traitements & Prix",
  "admin.nav_team": "Équipe",
  "admin.nav_reviews": "Avis",
  "admin.nav_bookings": "Réservations & RDV",
  "admin.nav_media": "Images & Médias",
  "admin.nav_translations": "Langues & Traductions",
  "admin.nav_footer": "Pied de page & Contact",
  "admin.nav_seo": "SEO",
  "admin.nav_settings": "Paramètres",
  "admin.breadcrumb_admin": "Admin",
  "admin.header_settings": "Paramètres",

  "admin.dashboard_title": "Tableau de Bord",
  "admin.dashboard_welcome": "Bon retour ! Voici votre aperçu.",
  "admin.stat_bookings": "Réservations",
  "admin.stat_bookings_sub": "{{count}} nouveau",
  "admin.stat_confirmed": "Confirmées",
  "admin.stat_confirmed_sub": "actif",
  "admin.stat_today": "Aujourd'hui",
  "admin.stat_today_sub": "Rendez-vous",
  "admin.stat_treatments": "Traitements",
  "admin.stat_treatments_sub": "Listes de prix",
  "admin.stat_team": "Équipe",
  "admin.stat_team_sub": "Membres",
  "admin.stat_reviews": "Avis",
  "admin.stat_reviews_sub": "Témoignages",

  "admin.upcoming_title": "Prochains Rendez-vous",
  "admin.today_label": "Aujourd'hui",
  "admin.upcoming_label": "À venir",
  "admin.no_future_bookings": "Aucun autre rendez-vous prévu.",
  "admin.view_all": "Voir tout",

  "admin.status_new": "Nouveau",
  "admin.status_confirmed": "Confirmé",
  "admin.status_done": "Terminé",

  "admin.activity_title": "Activités Récentes",
  "admin.activity_empty": "Aucune activité pour le moment.",
  "admin.activity_just_now": "à l'instant",
  "admin.activity_min_ago": "il y a {{count}} min",
  "admin.activity_hour_ago": "il y a {{count}} h",
  "admin.activity_day_ago": "il y a {{count}} jour",
  "admin.activity_days_ago": "il y a {{count}} jours",

  "admin.quick_title": "Accès Rapide",
  "admin.quick_home": "Modifier la Page d'Accueil",
  "admin.quick_bookings": "Gérer les Réservations",
  "admin.quick_pricing": "Modifier la Liste de Prix",
  "admin.quick_team": "Gérer l'Équipe",

  "admin.service_hair": "Greffe de Cheveux",
  "admin.service_dental": "Cosmétique Dentaire",
  "admin.service_botox": "Botox & Fillers",
  "admin.service_combined": "Traitement Combiné",
  "admin.service_consultation": "Consultation",

  "team.nertila-basha.title": "CEO, Dentiste, Implantologue & Prothésiste",
  "team.nertila-basha.specialty": "Implants dentaires & prothèses esthétiques",
  "team.nertila-basha.bio": "La Dre Nertila Basha est PDG, dentiste, implantologue et prothésiste avec une vaste expérience dans le domaine dentaire. Elle se distingue par la précision clinique et le soin des détails, en proposant des traitements modernes et individualisés pour chaque patient. Son objectif est de garantir des résultats fonctionnels et esthétiques au plus haut niveau, en plaçant toujours la santé et le bien-être du patient au centre de tout.",
  "team.nertila-basha.certifications": ["Spécialiste en Odontologie", "Implantologie & Prothèses", "Université de Tirana"],

  "team.denisa-zhegu.title": "Médecin de Médecine Esthétique",
  "team.denisa-zhegu.specialty": "Traitements dermo-esthétiques",
  "team.denisa-zhegu.bio": "La Dre Denisa Zhegu est médecin spécialiste en médecine esthétique avec une formation internationale, spécialisée dans les traitements dermo-esthétiques avancés. Elle se distingue par l'utilisation de techniques modernes et sûres, offrant des résultats naturels et personnalisés pour chaque patient. Grâce à son expérience et à sa formation continue, elle est une figure incontournable de la médecine esthétique à Tirana.",
  "team.denisa-zhegu.certifications": ["Spécialiste Médecine Esthétique", "Certification Dermo-esthétique", "Académie Internationale"],

  "team.nuri-qyra.title": "Anesthésiste & Réanimateur",
  "team.nuri-qyra.specialty": "Anesthésie & Sécurité du Patient",
  "team.nuri-qyra.bio": "Spécialiste avec plus de 40 ans d'expérience en anesthésie et en soins intensifs, dévoué à la sécurité, la surveillance et le confort maximal du patient lors de chaque procédure médicale et chirurgicale. Son calme et son expertise rassurent patients et équipe également.",
  "team.nuri-qyra.certifications": ["Spécialiste en Anesthésie", "Médecine Intensive", "Université de Tirana"],

  "team.nurie-paloka.title": "Infirmière-Chef de Bloc Opératoire",
  "team.nurie-paloka.specialty": "Assistance Chirurgicale & Gestion du Bloc Opératoire",
  "team.nurie-paloka.bio": "Fort de 37 ans d'expérience en assistance chirurgicale et en gestion du bloc opératoire, elle est dévouée au plus haut niveau de professionnalisme, d'organisation et de soins aux patients lors de chaque procédure médicale. Elle coordonne l'ensemble du déroulement des opérations avec précision et cœur.",
  "team.nurie-paloka.certifications": ["Infirmière-Chef de Bloc", "Assistance Chirurgicale", "Gestion Clinique"],

  "team.ermir-mehillej.title": "Chirurgien Implantologue",
  "team.ermir-mehillej.specialty": "Implantologie dentaire & Chirurgie",
  "team.ermir-mehillej.bio": "Le Dr Ermir Mehillej est dentiste et implantologue chirurgical avec 8 ans d'expérience dans le domaine. Il est spécialisé en implantologie traditionnelle, implants pterygoïdiens et zygomatiques, traitant même les cas les plus complexes avec précision et compétence. Grâce à son expérience, il propose des solutions sûres, fonctionnelles et esthétiquement avancées pour chaque patient.",
  "team.ermir-mehillej.certifications": ["Spécialiste en Odontologie", "Chirurgie Implantaire", "Implants Zygomatiques & Pterygoïdiens"],

  "team.roel-ferataj.title": "Chirurgien Implantologue",
  "team.roel-ferataj.specialty": "Implantologie dentaire & Chirurgie",
  "team.roel-ferataj.bio": "Le Dr Roel Ferataj est dentiste et implantologue chirurgical avec 4 ans d'expérience dans le domaine. Il est spécialisé en implantologie traditionnelle, implants pterygoïdiens et zygomatiques et se distingue par la précision et le soin apporté à chaque traitement, même dans les cas les plus complexes. Avec une approche professionnelle et une grande attention aux besoins du patient, il propose des solutions modernes, sûres et harmonieuses.",
  "team.roel-ferataj.certifications": ["Spécialiste en Odontologie", "Chirurgie Implantaire", "Implantologie Avancée"],

  "team.ana-bardhi.title": "Dentiste – Prothèses & Endodontie",
  "team.ana-bardhi.specialty": "Prothèses, Endodontie & Réhabilitation Esthétique",
  "team.ana-bardhi.bio": "La Dre Ana Bardhi est spécialiste en prothèses dentaires et en endodontie avec 6 ans d'expérience clinique. Elle s'occupe de la réhabilitation esthétique et fonctionnelle du sourire, en proposant des traitements personnalisés et des solutions modernes pour chaque patient. Grâce à son professionnalisme et sa minutie, elle garantit des soins de haute qualité dans un environnement accueillant et sûr.",
  "team.ana-bardhi.certifications": ["Spécialiste en Prothèses", "Spécialiste en Endodontie", "Odontologie Esthétique"],

  "team.rigers-xaka.title": "Assistant Dentaire",
  "team.rigers-xaka.specialty": "Assistance Clinique & Soins aux Patients",
  "team.rigers-xaka.bio": "Rigers Xaka est assistant dentaire avec 2 ans d'expérience dans le domaine dentaire. Il soutient l'équipe médicale lors des procédures cliniques et contribue à garantir un environnement organisé, sûr et accueillant pour les patients. Grâce à son professionnalisme et son attention aux détails, il assure une assistance efficace à chaque étape du traitement.",
  "team.rigers-xaka.certifications": ["Assistant Dentaire", "Soutien Clinique", "Gestion des Patients"],

  "team.luciana-basha.title": "Endodontiste",
  "team.luciana-basha.specialty": "Traitement Canalaire & Conservation des Dents Naturelles",
  "team.luciana-basha.bio": "Médecin endodontiste avec 3 ans d'expérience dans le traitement canalaire et la conservation des dents naturelles. Elle est dédiée à des traitements précis, peu invasifs et sans douleur, utilise des techniques modernes et place toujours le confort et la santé du patient en premier.",
  "team.luciana-basha.certifications": ["Spécialiste en Endodontie", "Spécialiste en Traitement Canalaire", "Université de Tirana"],

  "team.gezim-kabashi.title": "Chauffeur & Accompagnement Patient",
  "team.gezim-kabashi.specialty": "Soutien Organisationnel & Transport",
  "team.gezim-kabashi.bio": "Spécialisé dans l'accompagnement complet des patients tout au long de leur séjour en Albanie. Il offre un soutien organisationnel, une communication professionnelle et une expérience confortable depuis le moment de l'arrivée jusqu'à la fin du traitement.",
  "team.gezim-kabashi.certifications": ["Accompagnement Patients", "Chauffeur", "Gestion Organisationnelle"],

  "team.griselda.title": "Coordinatrice de Clinique",
  "team.griselda.specialty": "Gestion Clinique & Coordination des Patients",
  "team.griselda.bio": "Griselda est coordinatrice de clinique avec plus de 10 ans d'expérience dans la gestion et la coordination de cliniques et de structures hospitalières. Grâce à ses compétences organisationnelles et son attention envers les patients, elle garantit un parcours de traitement efficace, professionnel et bien organisé. Elle est le point de contact pour les soins et le soutien des patients à toutes les phases du traitement.",
  "team.griselda.certifications": ["Gestion Clinique", "Coordination des Patients", "Administration de la Santé"],
  "home.seo_service_areas_label": "Zones de service et traitements",
  "home.instagram_error": "Les publications Instagram n'ont pas pu être chargées.",
  "home.instagram_retry": "Réessayer",
  "home.instagram_empty_title": "Aucune publication pour le moment.",
  "home.instagram_empty_subtitle": "Suivez-nous sur Instagram pour des aperçus exclusifs.",
  "home.booking_reception_alt": "Réception Esteva Clinic",
  "home.newsletter_exists": "Cette adresse e-mail est déjà inscrite.",
  "home.newsletter_error": "Une erreur s'est produite. Veuillez réessayer.",
  "home.developed_by": "Développé par",
  "svc.pricing_hero_tag": "Liste des prix",
  "svc.savings_tag": "Comparatif de prix",
  "svc.savings_title": "Voici combien vous économisez en comparaison",
  "svc.savings_subtitle": "Même qualité, technologie de pointe — à une fraction du coût en Allemagne, en Autriche ou en Suisse.",
  "svc.savings_col_treatment": "Traitement",
  "svc.savings_col_savings": "Économies",
  "svc.packages_tag": "Forfaits de traitement",
  "svc.faq_heading": "Questions fréquemment posées",
  "svc.pricing_cta_subtitle": "Vous ne savez pas encore quel traitement vous convient ? Lors d'un entretien personnel, nous trouverons ensemble la solution idéale.",
  "svc.pricing_faq1_q": "Qu'est-ce qui est inclus dans les forfaits ?",
  "svc.pricing_faq1_a": "Chaque forfait comprend les traitements indiqués ainsi que le suivi mentionné. Lors d'un entretien personnel, nous clarifions tous les détails et adaptons le forfait précisément à vos besoins individuels.",
  "svc.pricing_faq2_q": "Y a-t-il des coûts cachés ?",
  "svc.pricing_faq2_a": "Non. Chez Esteva Clinic, la transparence est primordiale. Le prix convenu lors de l'entretien est contraignant. Il n'y a aucun frais supplémentaire caché.",
  "svc.pricing_faq3_q": "Puis-je combiner les traitements ?",
  "svc.pricing_faq3_a": "Bien sûr. Beaucoup de nos clients souhaitent une combinaison de différents traitements. Nous discutons volontiers des combinaisons individuelles lors de l'entretien.",
  "svc.pricing_faq4_q": "Quels modes de paiement acceptez-vous ?",
  "svc.pricing_faq4_a": "Nous acceptons les cartes de crédit (Visa, Mastercard, American Express), le virement bancaire ainsi que le paiement échelonné via notre partenaire. Vous en recevrez les détails lors d'un entretien personnel.",
  "svc.pricing_faq5_q": "Combien de temps dure le suivi ?",
  "svc.pricing_faq5_a": "Le suivi varie selon le traitement. Tous les rendez-vous de suivi ont lieu dans notre clinique à Tirana. Un plan détaillé est établi lors de votre consultation.",
  "svc.price_from": "à partir de ",
  "svc.price_fixed": "Prix fixe",
  "svc.view_details_link": "Voir les détails",
  "svc.dental_subtitle": "Des prix fixes transparents pour tous les traitements dentaires — y compris une technologie de pointe et des spécialistes expérimentés.",
  "svc.dental_cat_implants_label": "Implants",
  "svc.dental_cat_crowns_label": "Couronnes et bridges",
  "svc.dental_cat_aesthetics_label": "Esthétique et appareils dentaires",
  "svc.dental_cat_bone_label": "Greffe osseuse",
  "svc.dental_cat_prosthetics_label": "Prothèses",
  "svc.dental_cat_implants_desc": "Des implants modernes en matériaux de haute qualité pour une mastication ferme à vie.",
  "svc.dental_cat_crowns_desc": "Des couronnes très esthétiques en zircone ou en céramique — parfaitement assorties à la couleur de vos dents.",
  "svc.dental_cat_aesthetics_desc": "Votre plus beau sourire : du nettoyage professionnel à l'appareil dentaire invisible.",
  "svc.dental_cat_bone_desc": "Traitements préliminaires nécessaires pour un ancrage sûr de l'implant dans la mâchoire.",
  "svc.dental_cat_prosthetics_desc": "Une prise en charge prothétique flexible et confortable pour une meilleure qualité de vie.",
  "svc.surgery_subtitle": "Chirurgie plastique et esthétique au plus haut niveau — y compris tous les soins pré- et postopératoires à Tirana.",
  "svc.surgery_cat_face_label": "Visage et lifting",
  "svc.surgery_cat_breast_label": "Chirurgie mammaire",
  "svc.surgery_cat_body_label": "Remodelage corporel",
  "svc.surgery_cat_special_label": "Procédures spéciales",
  "svc.surgery_cat_face_desc": "La chirurgie esthétique la plus fine pour un profil facial harmonieux et naturel.",
  "svc.surgery_cat_breast_desc": "Des proportions naturellement belles grâce à des techniques chirurgicales de pointe et aux implants Mentor.",
  "svc.surgery_cat_body_desc": "Des contours corporels définis : de la liposuccion au raffermissement complet.",
  "svc.surgery_cat_special_desc": "Des procédures spéciales innovantes pour vos souhaits individuels.",
  "svc.hair_subtitle": "Technique FUE de pointe avec lames de saphir — des cheveux naturellement denses, sans cicatrices et à vie.",
  "svc.hair_bestseller": "Meilleure vente",
  "svc.hair_treatment_label": "Traitement",
  "svc.hair_total_price": "Prix total",
  "svc.hair_all_inclusive": "Forfait tout compris",
  "svc.hair_graft_overview": "Aperçu des forfaits de greffons",
  "svc.hair_popular": "Populaire",
  "svc.hair_ideal_for": "Idéal pour :",
  "svc.hair_included_title": "Inclus dans le forfait tout compris",
  "svc.hair_none_available": "Aucun traitement de greffe de cheveux disponible.",
  "svc.hair_tech_method_label": "Méthode",
  "svc.hair_tech_method_value": "FUE (Follicular Unit Extraction) — sans cicatrices",
  "svc.hair_tech_grafts_label": "Greffons",
  "svc.hair_tech_grafts_value": "Jusqu'à 5 000 greffons en une seule séance",
  "svc.hair_tech_duration_label": "Durée",
  "svc.hair_tech_duration_value": "6 à 8 heures (un rendez-vous)",
  "svc.hair_tech_anesthesia_label": "Anesthésie",
  "svc.hair_tech_anesthesia_value": "Anesthésie locale avec sédation",
  "svc.hair_tech_guarantee_label": "Garantie",
  "svc.hair_tech_guarantee_value": "Résultat dense à vie",
  "svc.hair_tech_return_label": "Voyage de retour",
  "svc.hair_tech_return_value": "Possible dès le 3e jour après l'opération",
  "svc.hair_incl_1": "Entretien personnel &amp; analyse capillaire",
  "svc.hair_incl_2": "Analyse sanguine &amp; bilan de santé",
  "svc.hair_incl_3": "Traitement FUE avec lames de saphir",
  "svc.hair_incl_4": "PRP (plasma riche en plaquettes) pour favoriser la guérison",
  "svc.hair_incl_5": "Kit de shampooing de soins post-opératoires spécial",
  "svc.hair_incl_6": "Tous les contrôles de suivi à Tirana",
  "svc.hair_graft1_count": "Jusqu'à 2 000",
  "svc.hair_graft1_desc": "Petites zones clairsemées &amp; golfes frontaux",
  "svc.hair_graft1_ideal": "Perte de cheveux légère",
  "svc.hair_graft2_desc": "Zone frontale &amp; tonsure",
  "svc.hair_graft2_ideal": "Perte de cheveux modérée",
  "svc.hair_graft3_desc": "Restauration complète",
  "svc.hair_graft3_ideal": "Perte de cheveux avancée",
  "svc.detail_not_found": "Traitement introuvable",
  "svc.detail_back_home": "Retour à l'accueil",
  "info.map_title": "Carte de l'emplacement de la Esteva Clinic",
  "info.hero_image_alt": "Prise de rendez-vous Esteva Clinic",
  "legal.location_title": "Emplacement",
  "legal.notfound_seo_title": "Page introuvable – Esteva Clinic",
  "legal.notfound_seo_description": "La page demandée est introuvable. Retournez à la page d'accueil d'Esteva Clinic.",
  "legal.notfound_title": "Cette page est introuvable",
  "legal.notfound_subtitle": "La page que vous recherchez n'existe pas.",
  "adm1.service_surgery": "Chirurgie",
  "adm1.saved": "Enregistré !",
  "adm1.save_error": "Erreur lors de l'enregistrement",
  "adm1.save_error_dot": "Erreur lors de l'enregistrement.",
  "adm1.save": "Enregistrer",
  "adm1.cancel": "Annuler",
  "adm1.delete": "Supprimer",
  "adm1.refresh": "Actualiser",
  "adm1.retry": "Réessayer",
  "adm1.filter_all": "Tous",
  "adm1.filter_visible": "Visible",
  "adm1.filter_hidden": "Masqué",
  "adm1.action_edit": "Modifier",
  "adm1.action_delete": "Supprimer",
  "adm1.action_hide": "Masquer",
  "adm1.action_show": "Afficher",
  "adm1.delete_irreversible": "Cette action est irréversible.",
  "adm1.label_name": "Nom",
  "adm1.label_email": "E-mail",
  "adm1.label_phone": "Téléphone",
  "adm1.label_package": "Forfait",
  "adm1.label_treatment": "Traitement",
  "adm1.label_status": "Statut :",
  "adm1.label_location": "Lieu",
  "adm1.label_date": "Date",
  "adm1.label_rating": "Note",
  "adm1.label_text": "Texte",
  "adm1.label_visible": "Visible",
  "adm1.label_verified": "Vérifié",
  "adm1.bookings_title": "Réservations et rendez-vous",
  "adm1.bookings_summary": "{{total}} réservations · {{new}} nouvelles · {{confirmed}} confirmées · {{done}} terminées",
  "adm1.bookings_load_error": "Erreur lors du chargement des réservations.",
  "adm1.bookings_status_error": "Le statut n'a pas pu être mis à jour.",
  "adm1.bookings_saved_notified": "Enregistré ! Le client sera informé.",
  "adm1.bookings_loading": "Chargement des réservations...",
  "adm1.bookings_empty_title": "Aucune réservation trouvée.",
  "adm1.bookings_empty_desc": "Les nouvelles réservations apparaissent ici dès qu'un patient demande un rendez-vous via le formulaire du site.",
  "adm1.reviews_title": "Avis",
  "adm1.reviews_summary": "{{total}} avis · {{visible}} visibles",
  "adm1.reviews_new": "Nouvel avis",
  "adm1.reviews_edit": "Modifier l'avis",
  "adm1.reviews_empty_title": "Aucun avis pour le moment.",
  "adm1.reviews_empty_desc": "Cliquez sur « Nouvel avis » pour ajouter le premier témoignage client.",
  "adm1.reviews_delete_confirm": "Supprimer l'avis ?",
  "adm1.team_title": "Équipe",
  "adm1.team_count": "{{count}} membres de l'équipe",
  "adm1.team_new": "Nouveau membre",
  "adm1.team_edit": "Modifier le membre",
  "adm1.team_delete_confirm": "Supprimer le membre ?",
  "adm1.label_title_role": "Titre / Rôle",
  "adm1.ph_title_role": "p. ex. PDG, dentiste",
  "adm1.label_specialty": "Spécialité",
  "adm1.ph_specialty": "p. ex. implants dentaires",
  "adm1.label_bio": "Bio",
  "adm1.label_certifications": "Certifications (séparées par des virgules)",
  "adm1.ph_certifications": "p. ex. spécialiste en dentisterie, implantologie",
  "adm1.label_languages": "Langues (séparées par des virgules, p. ex. DE, EN, IT)",
  "adm1.label_photo": "Photo",
  "adm1.label_order": "Ordre (numéro)",
  "adm1.treatments_title": "Traitements et tarifs",
  "adm1.treatments_summary": "{{count}} traitements · prix en €",
  "adm1.treatments_import": "Importer les traitements par défaut",
  "adm1.treatments_new": "Nouveau traitement",
  "adm1.treatments_edit": "Modifier le traitement",
  "adm1.treatments_empty": "Aucun traitement dans cette catégorie.",
  "adm1.treatments_delete_confirm": "Supprimer le traitement ?",
  "adm1.importing": "Importation…",
  "adm1.import_error": "Erreur d'importation",
  "adm1.col_treatment": "Traitement",
  "adm1.col_category": "Catégorie",
  "adm1.col_price_al": "Prix AL",
  "adm1.col_price_de": "Prix DE",
  "adm1.col_price_at": "Prix AT",
  "adm1.col_price_ch": "Prix CH",
  "adm1.col_savings": "Économie",
  "adm1.ph_treatment_name": "Nom du traitement",
  "adm1.label_description": "Description",
  "adm1.ph_description": "Description...",
  "adm1.label_price_al": "Prix Albanie (€)",
  "adm1.label_price_de": "Prix DE (€)",
  "adm1.label_price_at": "Prix AT (€)",
  "adm1.label_price_ch": "Prix CH (€)",
  "adm1.ph_price_range": "p. ex. 1 500 – 2 000",
  "adm1.label_savings_percent": "Économie (%)",
  "adm1.settings_title": "Paramètres",
  "adm1.settings_subtitle": "Gérer les paramètres globaux du site.",
  "adm1.settings_general": "Général",
  "adm1.settings_colors": "Couleurs",
  "adm1.settings_change_password": "Changer le mot de passe",
  "adm1.settings_saved_live": "Enregistré ! Les modifications sont aussitôt en ligne.",
  "adm1.label_website_name": "Nom du site",
  "adm1.label_logo_url": "URL du logo",
  "adm1.label_favicon_url": "URL du favicon",
  "adm1.label_primary_color": "Couleur principale",
  "adm1.label_accent_color": "Couleur d'accentuation",
  "adm1.label_secondary_color": "Couleur secondaire",
  "adm1.ph_new_password": "Nouveau mot de passe...",
  "adm1.pw_too_short": "Le mot de passe doit comporter au moins 6 caractères.",
  "adm1.pw_changed": "Mot de passe changé avec succès !",
  "adm1.footer_title": "Pied de page et contact",
  "adm1.footer_subtitle": "Coordonnées et paramètres du pied de page du site — exactement comme affichés sur la page.",
  "adm1.footer_contact_data": "Coordonnées",
  "adm1.footer_contact_data_desc": "Téléphone, e-mail, adresse, horaires d'ouverture — comme dans le pied de page et sur la page de contact",
  "adm1.footer_social_desc": "Instagram et TikTok — exactement comme liés dans le pied de page et sur la page de contact",
  "adm1.footer_tiktok_note": "Seul un espace réservé (#) est actuellement lié sur le site.",
  "adm1.footer_whatsapp_floating": "WhatsApp (bouton flottant)",
  "adm1.label_whatsapp_number": "Numéro (sans +, p. ex. 41765593993)",
  "adm1.label_whatsapp_message": "Message prédéfini",
  "adm1.footer_texts": "Textes du pied de page",
  "adm1.footer_texts_desc": "Slogan et copyright — comme dans le pied de page du site",
  "adm1.label_tagline": "Slogan (sous le logo)",
  "adm1.label_copyright": "Ligne de copyright",
  "adm1.label_address": "Adresse",
  "adm1.label_city_zip": "Ville / Code postal",
  "adm1.label_country": "Pays",
  "adm1.label_opening_hours": "Heures d'ouverture",
  "adm1.login_title": "Connexion admin",
  "adm1.login_subtitle": "Administration Esteva Clinic",
  "adm1.login_failed": "Échec de la connexion. E-mail ou mot de passe incorrect.",
  "adm1.label_password": "Mot de passe",
  "adm1.ph_enter_password": "Saisir le mot de passe",
  "adm1.pw_hide": "Masquer le mot de passe",
  "adm1.pw_show": "Afficher le mot de passe",
  "adm1.login_loading": "Connexion…",
  "adm1.login_submit": "Se connecter",
  "adm2.saved": "Enregistré !",
  "adm2.save_error": "Erreur lors de l'enregistrement.",
  "adm2.save": "Enregistrer",
  "adm2.cancel": "Annuler",
  "adm2.delete": "Supprimer",
  "adm2.edit": "Modifier",
  "adm2.upload": "Téléverser",
  "adm2.reset": "Réinitialiser",
  "adm2.reset_all": "Tout réinitialiser",
  "adm2.reset_lang": "Réinitialiser {{lang}}",
  "adm2.save_changes": "Enregistrer les modifications",
  "adm2.saving": "Enregistrement...",
  "adm2.saved_short": "Enregistré",
  "adm2.saved_live": "Enregistré ! Les modifications sont en ligne.",
  "adm2.remove": "Retirer",
  "adm2.changed": "Modifié",
  "adm2.optional": "facultatif",
  "adm2.preview": "Aperçu",
  "adm2.uploaded": "Téléversé",
  "adm2.uploading": "Téléversement…",
  "adm2.uploading_progress": "Téléversement en cours...",
  "adm2.upload_failed": "Échec du téléversement.",
  "adm2.upload_failed_retry": "Échec du téléversement. Veuillez réessayer.",
  "adm2.file_too_large": "Fichier trop volumineux (max. 5 Mo).",
  "adm2.file_too_large_compress": "Fichier trop volumineux (max. 5 Mo). Veuillez le compresser.",
  "adm2.file_too_large_max": "Le fichier est trop volumineux. Taille maximale : 5 Mo.",
  "adm2.max_5mb_jpg_png": "Max. 5 Mo, JPG ou PNG",
  "adm2.only_jpg_png_webp": "Veuillez téléverser uniquement des fichiers JPG, PNG ou WebP.",
  "adm2.only_image_files": "Veuillez sélectionner uniquement des fichiers image (JPG, PNG, WebP).",
  "adm2.file_read_error": "Erreur lors de la lecture du fichier. Veuillez réessayer.",
  "adm2.file_read_error_smaller": "Erreur lors de la lecture du fichier. Essayez un fichier plus petit.",
  "adm2.no_image": "Aucune image",
  "adm2.no_image_uploaded": "Aucune image téléversée pour le moment",
  "adm2.image_required": "Image requise",
  "adm2.edit_image": "Modifier l'image",
  "adm2.upload_image": "Téléverser une image",
  "adm2.remove_image": "Retirer l'image",
  "adm2.image_url": "URL de l'image",
  "adm2.image_url_optional": "URL de l'image (facultatif)",
  "adm2.enter_image_url": "Ou saisissez directement l'URL de l'image...",
  "adm2.image_upload_hint": "Téléversez une image depuis votre ordinateur ou collez une URL. Les images téléversées sont enregistrées localement.",
  "adm2.or_url": "ou URL...",
  "adm2.enter_url": "ou saisir une URL...",
  "adm2.location": "Emplacement",
  "adm2.description": "Description",
  "adm2.category": "Catégorie",
  "adm2.filter_all": "Tous",
  "adm2.media_title": "Images et médias",
  "adm2.media_uploaded_count": "{{uploaded}} / {{total}} images téléversées",
  "adm2.manage_images": "Gérer les images",
  "adm2.images": "Images",
  "adm2.images_count": "{{uploaded}} / {{total}} images",
  "adm2.customized": "Personnalisé",
  "adm2.no_images_category": "Aucune image dans cette catégorie.",
  "adm2.reset_all_images": "Réinitialiser toutes les images",
  "adm2.gallery_comparisons": "Comparaisons de la galerie",
  "adm2.gallery_before_after": "Galerie (Avant/Après)",
  "adm2.page_images": "Images des pages",
  "adm2.to_website": "Vers le site web",
  "adm2.gallery_intro": "Gérez les images de comparaison avant/après pour la page de la galerie. Chaque entrée comprend une image avant et une image après.",
  "adm2.new_comparison": "Nouvelle comparaison",
  "adm2.no_gallery_images_category": "Aucune image de galerie dans cette catégorie.",
  "adm2.before": "Avant",
  "adm2.after": "Après",
  "adm2.before_image": "Image avant",
  "adm2.after_image": "Image après",
  "adm2.no_label": "Sans étiquette",
  "adm2.months_count": "{{count}} mois",
  "adm2.new_before_after": "Nouvelle comparaison avant/après",
  "adm2.edit_comparison": "Modifier la comparaison",
  "adm2.add_comparison": "Ajouter une comparaison",
  "adm2.patient_label": "Étiquette patient",
  "adm2.patient_label_ph": "p. ex. Patient 29K",
  "adm2.treatment_label": "Étiquette du traitement",
  "adm2.treatment_label_ph": "p. ex. Esthétique dentaire",
  "adm2.result_after_months": "Résultat après (mois)",
  "adm2.result_desc_ph": "Brève description du résultat...",
  "adm2.cat_hero": "Hero et arrière-plans",
  "adm2.cat_services": "Services / Prestations",
  "adm2.cat_about": "À propos / Clinique",
  "adm2.cat_pricing": "Prix / Forfaits",
  "adm2.cat_gallery": "Galerie (Avant/Après)",
  "adm2.cat_team": "Équipe",
  "adm2.cat_instagram": "Instagram / Réseaux sociaux",
  "adm2.gcat_dental": "Esthétique dentaire",
  "adm2.gcat_surgery": "Chirurgie",
  "adm2.gcat_hair": "Greffe de cheveux",
  "adm2.gcat_aesthetic": "Esthétique",
  "adm2.img_home_hero_bg": "Accueil — Arrière-plan hero",
  "adm2.img_home_cta_bg": "Accueil — Arrière-plan CTA",
  "adm2.img_home_process": "Accueil — Arrière-plan processus",
  "adm2.img_home_trust": "Accueil — Arrière-plan confiance",
  "adm2.img_about_hero": "À propos — Hero (Tirana)",
  "adm2.img_services_hero": "Prestations — Hero",
  "adm2.img_pricing_hero": "Prix — Hero",
  "adm2.img_gallery_hero": "Galerie — Hero",
  "adm2.img_booking_hero": "Réservation — Hero",
  "adm2.img_hair": "Greffe de cheveux — Image",
  "adm2.img_dental": "Esthétique dentaire — Image",
  "adm2.img_botox": "Botox et fillers — Image",
  "adm2.confirm_delete": "Voulez-vous vraiment supprimer ?",
  "adm2.no_subscribers": "Aucun abonné disponible.",
  "adm2.csv_email": "E-mail",
  "adm2.csv_language": "Langue",
  "adm2.csv_status": "Statut",
  "adm2.csv_date": "Date",
  "adm2.col_email": "E-mail",
  "adm2.col_language": "Langue",
  "adm2.col_status": "Statut",
  "adm2.col_date": "Date",
  "adm2.col_actions": "Actions",
  "adm2.pages_content_title": "Pages et contenu",
  "adm2.pages_content_subtitle": "Modifiez le contenu de chaque page du site web.",
  "adm2.language_label": "Langue :",
  "adm2.editable_fields_count": "{{count}} champs modifiables",
  "adm2.editable_fields_count2": "{{count}} champs modifiables",
  "adm2.no_fields_configured": "Aucun champ configuré pour cette page.",
  "adm2.pc_page_home": "Accueil",
  "adm2.pc_page_services": "Prestations",
  "adm2.pc_page_about": "À propos",
  "adm2.pc_page_pricing": "Prix",
  "adm2.pc_page_gallery": "Galerie",
  "adm2.pc_page_team": "Équipe",
  "adm2.pc_page_booking": "Réservation",
  "adm2.pc_page_contact": "Contact",
  "adm2.pc_hero_headline": "Titre hero",
  "adm2.pc_hero_subline": "Sous-titre hero",
  "adm2.pc_hero_button": "Bouton hero",
  "adm2.pc_about_heading": "Titre À propos",
  "adm2.pc_about_text": "Texte À propos",
  "adm2.pc_services_heading": "Titre Prestations",
  "adm2.pc_pricing_heading": "Titre Prix",
  "adm2.pc_testimonials_heading": "Titre Avis",
  "adm2.pc_hair_title": "Titre Greffe de cheveux",
  "adm2.pc_hair_desc": "Description Greffe de cheveux",
  "adm2.pc_hair_heading": "Titre Greffe de cheveux",
  "adm2.pc_dental_title": "Titre Esthétique dentaire",
  "adm2.pc_dental_desc": "Description Esthétique dentaire",
  "adm2.pc_dental_heading": "Titre Esthétique dentaire",
  "adm2.pc_botox_title": "Titre Botox et fillers",
  "adm2.pc_botox_desc": "Description Botox et fillers",
  "adm2.pc_botox_heading": "Titre Botox et fillers",
  "adm2.pc_story_title": "Titre Notre histoire",
  "adm2.pc_story_text": "Texte Notre histoire",
  "adm2.pc_philosophy_title": "Titre Philosophie",
  "adm2.pc_philosophy_text": "Texte Philosophie",
  "adm2.pc_form_heading": "Titre du formulaire",
  "adm2.pc_ph_home_hero_title": "p. ex. Votre clinique premium à Tirana",
  "adm2.pc_ph_home_hero_sub": "p. ex. Des traitements de haute qualité à des prix équitables...",
  "adm2.pc_ph_home_hero_cta": "p. ex. Prendre rendez-vous maintenant",
  "adm2.pc_ph_about_title": "p. ex. À propos d'Esteva Clinic",
  "adm2.pc_ph_clinic_desc": "Description de la clinique...",
  "adm2.pc_ph_our_services": "p. ex. Nos prestations",
  "adm2.pc_ph_pricing_packages": "p. ex. Nos forfaits",
  "adm2.pc_ph_testimonials": "p. ex. Ce que disent nos clients",
  "adm2.pc_ph_services_sub": "p. ex. Découvrez notre gamme complète de traitements...",
  "adm2.pc_ph_hair": "p. ex. Greffe de cheveux",
  "adm2.pc_ph_dental": "p. ex. Esthétique dentaire",
  "adm2.pc_ph_botox": "p. ex. Botox et fillers",
  "adm2.pc_ph_description": "Description...",
  "adm2.pc_ph_about_sub": "p. ex. Votre clinique premium au cœur de Tirana...",
  "adm2.pc_ph_our_story": "p. ex. Notre histoire",
  "adm2.pc_ph_clinic_story": "L'histoire de la clinique...",
  "adm2.pc_ph_our_philosophy": "p. ex. Notre philosophie",
  "adm2.pc_ph_our_prices": "p. ex. Nos prix",
  "adm2.pc_ph_pricing_sub": "p. ex. Prix transparents — jusqu'à 70 % moins chers...",
  "adm2.pc_ph_gallery_title": "p. ex. Galerie avant-après",
  "adm2.pc_ph_gallery_sub": "p. ex. Résultats réels de nos traitements...",
  "adm2.pc_ph_our_team": "p. ex. Notre équipe",
  "adm2.pc_ph_team_sub": "p. ex. Faites connaissance avec nos experts...",
  "adm2.pc_ph_book_appt": "p. ex. Prendre rendez-vous",
  "adm2.pc_ph_booking_sub": "p. ex. Planifiez votre rendez-vous de consultation maintenant...",
  "adm2.pc_ph_your_data": "p. ex. Vos coordonnées",
  "adm2.pc_ph_contact": "p. ex. Contact",
  "adm2.pc_ph_contact_sub": "p. ex. Comment nous joindre...",
  "adm2.edit_page_title": "Modifier {{page}}",
  "adm2.manage_team_members": "Gérer les membres de l'équipe",
  "adm2.edit_pricing_treatments": "Modifier les traitements de la liste de prix",
  "adm2.saved_de_synced": "Enregistré ! (DE → appliqué automatiquement à toutes les langues) Les modifications sont maintenant en ligne.",
  "adm2.saved_lang_live": "Enregistré ! ({{lang}}) Les modifications sont maintenant en ligne.",
  "adm2.changes_reset_for": "Toutes les modifications pour {{lang}} ont été réinitialisées.",
  "adm2.lang_editor": "Éditeur de langue ({{lang}})",
  "adm2.lang_editor_de_note": "Vous modifiez la version DE. Les modifications sont automatiquement appliquées à toutes les langues (EN, IT, ES, FR).",
  "adm2.lang_editor_other_note": "Vous modifiez actuellement la version {{lang}}. Les modifications sont enregistrées séparément pour cette langue.",
  "adm2.texts": "Textes",
  "adm2.key_label": "Clé :",
  "adm2.changed_original": "Modifié — original :",
  "adm2.no_editable_fields": "Aucun champ modifiable",
  "adm2.no_configured_fields": "Cette page n'a pas encore de champs configurés.",
  "adm2.read_only": "Lecture seule",
  "adm2.translations_info": "Les traductions sont gérées directement dans les fichiers de langue. Cette page affiche les valeurs actuelles à titre de consultation. Pour toute modification, veuillez contacter votre développeur.",
  "adm2.pe_cat_dental": "Dentisterie",
  "adm2.pe_cat_surgery": "Chirurgie plastique",
  "adm2.pe_cat_hair": "Greffe de cheveux",
  "adm2.pe_new_treatment": "Nouveau traitement",
  "adm2.pe_default_stay": "Hôpital de jour / 2 nuits d'hôtel (3 jours)",
  "adm2.pe_category_reset": "Tous les traitements {{category}} pour {{lang}} ont été réinitialisés.",
  "adm2.pe_confirm_reset_all": "Voulez-vous vraiment réinitialiser TOUTES les listes de prix dans TOUTES les langues ? Cette action est irréversible.",
  "adm2.pe_all_reset": "Toutes les listes de prix ont été entièrement réinitialisées.",
  "adm2.pe_treatments_count": "{{count}} traitement(s)",
  "adm2.pe_edit_hint": "Modifiez le nom, le prix et éventuellement la durée du séjour.",
  "adm2.pe_saved_lang": "Enregistré ! ({{lang}})",
  "adm2.pe_treatment_name": "Nom du traitement",
  "adm2.pe_price_eur": "Prix (€)",
  "adm2.pe_price_ph": "p. ex. 350 – 400",
  "adm2.pe_stay": "Séjour",
  "adm2.pe_stay_ph": "p. ex. Hôpital de jour / 2 nuits d'hôtel",
  "adm2.pe_no_treatments_lang": "Aucun traitement dans cette langue",
  "adm2.pe_no_treatments_hint": "Ajoutez un nouveau traitement ou réinitialisez les données par défaut.",
  "adm2.pe_add_treatment": "Ajouter un traitement",
  "adm2.pe_total_treatments": "Total : {{count}} traitements en {{lang}}",
  "adm2.pe_short_dental": "Dentaire",
  "adm2.pe_short_surgery": "Chirurgie",
  "adm2.pe_short_hair": "Cheveux",
  "adm2.tm_lang_de": "Allemand",
  "adm2.tm_lang_it": "Italien",
  "adm2.tm_lang_en": "Anglais",
  "adm2.tm_lang_fr": "Français",
  "adm2.tm_lang_es": "Espagnol",
  "adm2.tm_lang_nl": "Néerlandais",
  "adm2.tm_lang_pl": "Polonais",
  "adm2.tm_lang_al": "Albanais",
  "adm2.tm_members_count": "Membres de l'équipe ({{count}})",
  "adm2.tm_add_member": "Ajouter un membre",
  "adm2.tm_no_members": "Aucun membre de l'équipe pour le moment.",
  "adm2.tm_add_first_member": "Ajouter le premier membre",
  "adm2.tm_new_member": "Nouveau membre",
  "adm2.tm_edit_member": "Modifier le membre",
  "adm2.tm_profile_image": "Photo de profil",
  "adm2.tm_upload_image_max": "Téléverser une image (max. 5 Mo)",
  "adm2.tm_image_hint": "Image carrée recommandée. Max. 5 Mo.",
  "adm2.tm_name": "Nom",
  "adm2.tm_name_ph": "p. ex. Nertila Basha",
  "adm2.tm_title_position": "Titre / Poste",
  "adm2.tm_title_ph": "p. ex. PDG, Dentiste",
  "adm2.tm_specialty": "Spécialité",
  "adm2.tm_specialty_ph": "p. ex. Implants dentaires et prothèses esthétiques",
  "adm2.tm_bio": "Biographie",
  "adm2.tm_bio_ph": "Brève biographie du membre de l'équipe...",
  "adm2.tm_languages": "Langues",
  "adm2.tm_certifications": "Certificats et qualifications",
  "adm2.tm_cert_ph": "Certificat {{num}}",
  "adm2.tm_add_cert": "Ajouter un certificat",
  "shared.chat_title": "Assistant Esteva",
  "shared.chat_online": "En ligne",
  "shared.chat_restart": "Recommencer",
  "shared.close": "Fermer",
  "shared.book_appointment": "Prendre rendez-vous",
  "shared.chat_input_placeholder": "Écrire un message...",
  "shared.send": "Envoyer",
  "shared.chat_close": "Fermer le chat",
  "shared.chat_open": "Ouvrir le chat",
  "shared.whatsapp_contact": "Contact WhatsApp",
  "shared.whatsapp_tooltip": "Écrivez-nous maintenant sur WhatsApp",
  "shared.select_language": "Choisir la langue",
  "shared.image": "Image",
  "shared.image_too_large": "Fichier trop volumineux (max. 10 Mo).",
  "shared.image_upload_failed": "Échec du téléversement. Veuillez réessayer.",
  "shared.image_uploading": "Téléversement…",
  "shared.image_select": "Choisir une image",
  "shared.image_url_placeholder": "ou coller une URL d'image…",
  "shared.open_menu": "Ouvrir le menu",
};

export default common;